import { put, call, all, takeLatest, cancelled } from 'redux-saga/effects';
import { ADMIN } from '../../../actionTypes';
import { APIUSER, APICOMMON } from '../../../actionApi';
import { ACTIONCOMMON } from '../../../actionTypes';
import { request } from '../../../utils/request';
import { API } from '../../../env';
import { readCookie } from '../../../utils/common';
function* getPromotion(action) {
	console.log('action', action);
	let { payload, callback } = action;
	let task = yield call(request, {
		type: 'GET',
		url: API.COMMON_PORXY + APICOMMON.PROMOTION,
		dataParam: {
			...payload
		}
	});
	yield put({ type: ADMIN.SET_PROMOTION, data: task.result });
	return callback && callback(task.result);
	// }
}
function* postPromotion(action) {
	let { callback, errorCallback } = action;
	let res = yield call(request, {
		type: 'PUT',
		url: API.COMMON_PORXY + APICOMMON.PROMOTION,
		dataParam: {
			...action.data
		}
	});
	let { ok, status, result = {} } = res || {};
	if (status === 200) {
		yield put({ type: ACTIONCOMMON.SET_COMMON_HOMEPAGE, payload: { wallSwith: action.data.wallSwith, vphotoSwitch: action.data.vphotoSwitch, moduleName: action.data.moduleName } });
		return callback && callback(result);
	}
	return errorCallback && errorCallback(result);
}
let promotionSaga = [takeLatest(ADMIN.GET_PROMOTION, getPromotion), takeLatest(ADMIN.POST_PROMOTION, postPromotion)];
export { promotionSaga };
